export default {
      id: "visibility-usage",
      viewBox: "0 0 15 12",
      url: __webpack_public_path__ + "sprite-46b249.svg#visibility-usage",
      toString: function () {
        return this.url;
      }
    }